<template src="./support_ticket.html"></template>
<script>

import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import $ from "jquery";
  export default {
    props: [],
    data() {
      return {
        CompanyDetails:[],
        UserDetails:[],
        SupportTicket: {
          company_name:"",
          user_name:"",
          email:"",
          subject: "",
          type: "",
          description: "",
        },
        NotificationSubmitted: false,
        submitted: false,
      };
    },
    validations: {
      SupportTicket: {
        user_name: { required },
        subject: { required },
        type: { required },
        description: { required },
      },
    },
    mounted() {
      this.CompanyDetails = JSON.parse(localStorage.getItem("Company"));
      this.UserDetails = JSON.parse(localStorage.getItem("User"));
      this.SupportTicket.company_name = this.CompanyDetails.name;
      this.SupportTicket.user_name = this.UserDetails.forename+' '+this.UserDetails.surname;
      this.SupportTicket.email = this.UserDetails.email;
    },
    methods: {
      saveMessage() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          
        this.NotificationSubmitted = false;
          return;
        }
        
        this.NotificationSubmitted = true;
        axios
          .post(Endpoints.SupportTicket.Create, {
            token: localStorage.getItem("token"),
            ...this.SupportTicket,
          })
          .then((Response) => {
            this.NotificationSubmitted = false;
            this.submitted = false;
            if (Response?.data?.success) {
              this.$swal
                .fire("Message has been Sent Successfully", "", "success")
                .then(() => {
                  $('#support-ticket-form .close').trigger('click');
                  this.SupportTicket.type = "";
                  this.SupportTicket.description = "";
                });
            } else {
              this.$swal.fire({
                title: "Alert!",
                text: Response?.data?.message || "Something went wrong",
                icon: "error",
                confirmButtonText: "Close",
              });
            }
          });
      },
    },
  };
</script>
<style scoped>
  #send-message___BV_modal_outer_ {
    z-index: 1050 !important;
  }
</style>